export class GridgetIds {
  static HISTORICAL_PEAK = 'historicalPeakGridget';
  static BUILDINGS_IMPACTED = 'buildingsImpactedGridget';
  static ROADS_AFFECTED = 'roadsAffectedGridget';
  static BRIDGES_IMPACTED = 'bridgesImpactedGridget';
}